import type { MenuScreen } from '../types.js';
import {
  createScreenShell,
  createMenuHeader,
  createCrestButton,
  createSettingsPanel,
  el,
} from '@bn-games/ui-shell';
import { buildSettingsRows } from '../settingsRows.js';
import { t } from '../../i18n/I18n.js';

export function createSettingsScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const body = shell.body;

      body.appendChild(createMenuHeader({ title: t('settings.title') }));

      const panel = createSettingsPanel({
        getRows: () => buildSettingsRows({ ctx }),
        tabs: [
          { id: 'gameplay', label: t('settings.tabs.gameplay') },
          { id: 'interface', label: t('settings.tabs.interface') },
        ],
      });
      body.appendChild(panel.element);

      const back = el('div', { class: 'button-row back-button-row' }, [
        createCrestButton({
          label: t('common.back'),
          small: true,
          onClick: () => ctx.navigate('menu'),
        }),
      ]);
      body.appendChild(back);

      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
